<template>
  <div class="content-wrap">
    <div class="info-card-wrap show-bottom-line">
      <div class="detail-title">
        {{ workInfo.projectName }}
      </div>
    </div>
    <div style="map-preview-wrap">
      <img
        :src="mapPreview"
        style="width: 100%"
      >
    </div>
    <div class="info-card-wrap">
      <div class="info-item">
        <div class="item-label">
          任务单号：
        </div>
        <div class="item-content">
          {{ workInfo.taskNo }}
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          工程名称：
        </div>
        <div class="item-content">
          {{ workInfo.projectName }}
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          客户名称：
        </div>
        <div class="item-content">
          {{ workInfo.customerName }}
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          施工部位：
        </div>
        <div class="item-content">
          {{ workInfo.workArea }}
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          施工地址：
        </div>
        <div class="item-content">
          {{ workInfo.workAddress }}
        </div>
      </div>
    </div>
    <div class="model-title">
      运输信息
    </div>
    <div class="info-card-wrap show-bottom-line">
      <div class="info-item">
        <div class="item-label">
          发货人：
        </div>
        <div class="item-content">
          {{ workInfo.shipping }}
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          发货时间：
        </div>
        <div class="item-content">
          {{ workInfo.transTime }}
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          运输车号：
        </div>
        <div class="item-content">
          {{ workInfo.transCarNo }}
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          驾驶员：
        </div>
        <div class="item-content">
          {{ workInfo.driver }}
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          到达时间：
        </div>
        <div class="item-content">
          {{ workInfo.arrivalTime }}
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          签收人：
        </div>
        <div class="item-content">
          {{ workInfo.delivery }}
        </div>
      </div>
    </div>
    <div class="model-title">
      产品信息
    </div>
    <div class="info-card-wrap">
      <div class="info-item">
        <div class="item-label">
          搅拌站号：
        </div>
        <div class="item-content">
          {{ workInfo.nixingNo }}
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          生产日期：
        </div>
        <div class="item-content">
          {{ workInfo.createTime }}
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          强度等级：
        </div>
        <div class="item-content">
          {{ workInfo.strongLevel }}
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          塌落度：
        </div>
        <div class="item-content">
          {{ workInfo.collapseDegree }}
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          施工方式：
        </div>
        <div class="item-content">
          {{ workInfo.workType }}
        </div>
      </div>
    </div>
    <div class="model-title">
      其他信息
    </div>
    <div class="info-card-wrap">
      <div class="info-item">
        <div class="item-label">
          本车放量：
        </div>
        <div class="item-content">
          {{ workInfo.square }}㎥
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          累计方量：
        </div>
        <div class="item-content">
          {{ workInfo.totalSquare }}㎥
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">
          累计车次：
        </div>
        <div class="item-content">
          {{ workInfo.totalCarNum }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mapPreview from "@/assets/map-preview.jpg";

const defaultData = {
  nixingNo: "3号站",
  createTime: "2021-12-16",
  projectName: "赣州市启迪科技城二期",
  customerName: "江西凯驰建设工程有限公司",
  transCarNo: "外租77",
  square: 20,
  driver: "租车",
  totalCarNum: 3,
  workArea: "科技园C11-3-2栋3层板",
  taskNo: "211214032SJ",
  totalSquare: 42,
  workAddress: "",
  transTime: "2021-12-16 10:48:27",
  shipping: "管理员",
  strongLevel: "C30",
  arrivalTime: "",
  delivery: "",
  collapseDegree: "180±30",
  workType: "泵送",
  address: "赣州市沙河工业园坳下桥头323国道旁",
};
export default {
  data: () => ({
    mapPreview,
    workInfo: defaultData,
  }),
  computed: {},
  methods: {
    handleClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.detail-title {
  text-align: center;
}

.model-title {
    padding: 6px 12px;
    font-size: 16px;
    font-weight: bold;
}
.info-card-wrap {
  position: relative;
  box-sizing: border-box;
  padding: 12px;
  background-color: #ffffff;

  &.show-bottom-line {
    border-bottom: solid 1px #e8e8e8;
  }
  &.show-color-bar::before {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 2px;
    background: repeating-linear-gradient(
      -45deg,
      #ff6c6c 0,
      #ff6c6c 20%,
      transparent 0,
      transparent 25%,
      #1989fa 0,
      #1989fa 45%,
      transparent 0,
      transparent 50%
    );
    background-size: 21.33333vw;
    content: "";
  }
}

.info-item {
  display: flex;
  font-size: 14px;

  + .info-item {
    margin-top: 4px;
  }
  .item-label {
    width: 5em;
  }
  .item-content {
    flex: 1;
  }
}
</style>